import { buildSchema, buildProperty } from "@camberi/firecms";

export const mediaSchema = buildSchema({
    name: "Media",
    properties: {
        name: {
            title: "Name",
            dataType: "string",
            validation: { required: true },
        },
        mediaUrl: buildProperty({
            title: "Media",
            dataType: "string",
            validation: { required: true },
            config: {
                storageMeta: {
                    mediaType: "image",
                    storagePath: `images/${new Date().toLocaleDateString('en-CA')}/${new Date().getTime()}`,
                    storeUrl: true,
                    acceptedFiles: ["image/*"],
                    metadata: {
                        cacheControl: "max-age=1000000"
                    }
                },
                fileName: (context: any) => {
                    return Math.random()  + "-" + context.file.name;
                }
            }
        }),
        createdAt: buildProperty({
            title: "Created At",
            dataType: "timestamp",
            validation: { required: true },
            columnWidth: 300,
        }),
    }
});
